import { QueryParams } from '~constants/routes'
import { AuthMode } from '~pages/AuthorizationPages/types'
import { SettingsTabs } from '~modals/SettingsModal/Menu/const'

enum SortOrder {
    asc = 'asc',
    desc = 'desc',
}

enum SortColumn {
    price = 'price',
    change = 'change',
    volume = 'volume',
    name = 'name',
}

export interface GenerateQueryProps {
    type?: 'crypto' | 'fiat' // TODO: set explicit type
    settings?: SettingsTabs
    action?: 'topup'
    cardId?: string
    toCurrency?: string
    fromCurrency?: string
    amount?: string
    refId?: string
    recipient?: string
    auth?: AuthMode
    withQuestionMark?: boolean
    currency?: string
    txType?: string
    sumsubLevel?: string
    onlyFavorites?: boolean
    sort?: `${SortColumn}-${SortOrder}`
    network?: string
    paymentId?: string
}

// TODO: move to navigation folder

// eslint-disable-next-line complexity
export const generateQuery = ({
    type,
    toCurrency,
    fromCurrency,
    amount,
    refId,
    auth,
    recipient,
    withQuestionMark = true,
    settings,
    currency,
    txType,
    sumsubLevel,
    onlyFavorites,
    sort,
    action,
    cardId,
    network,
    paymentId,
}: GenerateQueryProps) => {
    const params = new URLSearchParams()
    type && params.set(QueryParams.type, type)
    auth && params.set(QueryParams.auth, auth)
    refId && params.set(QueryParams.refId, refId)
    toCurrency && params.set(QueryParams.toCurrency, toCurrency)
    fromCurrency && params.set(QueryParams.fromCurrency, fromCurrency)
    amount && params.set(QueryParams.amount, amount)
    settings && params.set(QueryParams.settings, settings)
    recipient && params.set(QueryParams.recipient, recipient)
    currency && params.set(QueryParams.currency, currency)
    txType && params.set(QueryParams.txType, txType)
    sumsubLevel && params.set(QueryParams.sumsubLevel, sumsubLevel)
    onlyFavorites && params.set(QueryParams.onlyFavorites, String(onlyFavorites))
    sort && params.set(QueryParams.sort, sort)
    action && params.set(QueryParams.action, action)
    cardId && params.set(QueryParams.cardId, cardId)
    network && params.set(QueryParams.network, network)
    paymentId && params.set(QueryParams.paymentId, paymentId)

    const queryString = params.toString()

    if (withQuestionMark && queryString) {
        return `?${queryString}`
    }

    return queryString
}
